import { render } from "./AboutProcess.vue?vue&type=template&id=5b97d4ad"
import script from "./AboutProcess.vue?vue&type=script&lang=js"
export * from "./AboutProcess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__